import { FormControl } from 'baseui/form-control'
import { Input } from 'baseui/input'

import SDButton from '@/shared/components/SDComponentsNewDesign/SDButton/SDButton'
import SDNotification from '@/shared/components/SDComponentsNewDesign/SDNotification/SDNotification'

import useBreakSettingsForm from './useBreakSettingsForm'
import { SettingsRow, SettingsSection, SectionTitle, SubmitButtonOverrides } from '../styled-components'

interface BreakSettingsFormProps {
  hidden: boolean
}

const BreakSettingsForm = ({ hidden }: BreakSettingsFormProps) => {
  const {
    t,
    maxWeekday,
    maxSaturday,
    onMaxWeekdayChange,
    onMaxSaturdayChange,
    maxCap,
    settingsError,
    inputsDisabled,
    weekdayError,
    saturdayError,
    canSubmit,
    submit,
  } = useBreakSettingsForm()

  if (hidden) return null

  return (
    <SettingsSection>
      <SDNotification type='negative' hidden={!settingsError} primaryText={String(settingsError ?? '')} />
      <SettingsRow>
        <div>
          <SectionTitle>{t('breakManagement:settings.weekday')}</SectionTitle>
          <FormControl label={`${t('breakManagement:settings.max')} *`}>
            <Input
              id='break-max-weekday'
              type='number'
              min={0}
              max={maxCap}
              disabled={inputsDisabled}
              value={maxWeekday}
              error={weekdayError}
              onChange={onMaxWeekdayChange}
            />
          </FormControl>
        </div>
        <div>
          <SectionTitle>{t('breakManagement:settings.saturday')}</SectionTitle>
          <FormControl label={`${t('breakManagement:settings.max')} *`}>
            <Input
              id='break-max-saturday'
              type='number'
              min={0}
              max={maxCap}
              disabled={inputsDisabled}
              value={maxSaturday}
              error={saturdayError}
              onChange={onMaxSaturdayChange}
            />
          </FormControl>
        </div>
      </SettingsRow>
      {/* @ts-expect-error SDButton is a JS component */}
      <SDButton id='break-settings-submit-btn' disabled={!canSubmit} onClick={submit} overrides={SubmitButtonOverrides}>
        {t('breakManagement:settings.submit')}
      </SDButton>
    </SettingsSection>
  )
}

export default BreakSettingsForm
